export const dateFormat = (dateString) => {
    return dateString && new Date(dateString).toLocaleDateString("fr");
};